import { createContext } from 'react';
import initialCatalogTarifsState from './initialCatalogTarifsState';

const CatalogTarifsContext = createContext(initialCatalogTarifsState);

export default CatalogTarifsContext;
